import clsx from "clsx";

interface Props {
	className?: string;
	opacity?: boolean;
}
export default function Divider({ className, opacity = false }: Props) {
	return <div className={clsx(opacity ? "f2_19_bottom_50" : "f2_19_bottom", className)}></div>;
}
